import React from "react";
import {
  AppstoreOutlined,
  BookOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  BarChartOutlined,
  SafetyOutlined,
  BankOutlined,
  DollarOutlined,
  ThunderboltOutlined,
  DatabaseOutlined,
  MedicineBoxOutlined,
} from '@ant-design/icons';
import { getUserDetails } from '../../utils/helper';

export const NavigationItems = (onNavChange, userType) => {
  // Check if aggregated stats is enabled
  const isAggregatedStatsEnabled = window.ENV_CONFIG?.ENABLE_AGGREGATED_STATS || false;

  // Build analytics children dynamically
  const analyticsChildren = [
    { key: 'analytics_dashboard', label: 'Dashboard' }
  ];

  // Only add Center Performance if aggregated stats is enabled
  if (isAggregatedStatsEnabled) {
    analyticsChildren.push({ key: 'center_analytics', label: 'Center Performance' });
  }

  // Check if session tracking is enabled
  const isSessionTrackingEnabled = window.ENV_CONFIG?.ENABLE_SESSION_TRACKING || false;


  if (userType === 'support_admin') {
    return [{
      key: 'users',
      label: 'Manage Users',
      icon: <MailOutlined />,
      children: [
        { key: 'users_list', label: 'Users' },
      ],
    }]
  }

  const items = [
    {
      key: 'analytics',
      label: 'Analytics',
      icon: <BarChartOutlined />,
      children: analyticsChildren,
    },
    {
      key: 'users',
      label: 'Manage Users',
      icon: <MailOutlined />,
      children: [
        { key: 'users_list', label: 'Users' },
        { key: 'add_user', label: 'Add User' },
      ],
    },
    {
      key: 'masters',
      label: 'Masters',
      icon: <DatabaseOutlined />,
      children: [
        { key: 'modalities_master', label: 'Modalities' },
        { key: 'modality_groups', label: 'Modality Groups' },
        { key: 'body_parts_master', label: 'Body Parts' },
        { key: 'item_codes', label: 'Item Codes' },
        { key: 'modality_locations', label: 'Modality Locations' },
        { key: 'hl7_routing', label: 'HL7 Routing' },
      ],
    },
    {
      key: 'referral_physicians',
      label: 'Referral Physician',
      icon: <MedicineBoxOutlined />,
      children: [
        { key: 'referral_physicians_list', label: 'Manage Physicians' },
      ],
    },
    {
      key: 'nodes',
      label: 'Node Configuration',
      icon: <AppstoreOutlined />,
      children: [
        { key: 'nodes_list', label: 'Nodes List' },
        { key: 'add_node', label: 'Add New Node' },
      ],
    },
    // {
    //   key: 'templates',
    //   label: 'Templates',
    //   icon: <AppstoreOutlined />,
    //   children: [
    //     { key: 'templates_list', label: 'Templates List' },
    //     { key: 'add_template', label: 'Add New Template' },
    //   ],
    // },
    {
      key: 'oo_templates',
      label: 'Templates',
      icon: <AppstoreOutlined />,
      children: [
        { key: 'oo_templates_list', label: 'Templates List (.docx)' },
        { key: 'oo_add_template', label: 'Add New Template (.docx)' },
      ],
    },
    {
      key: 'centers',
      label: 'Centers',
      icon: <BankOutlined />,
      children: [
        { key: 'centers_list', label: 'Centers List' },
        { key: 'add_center', label: 'Add New Center' },
      ],
    },
    {
      key: 'report_config',
      label: 'Report Configuration',
      icon: <ContainerOutlined />,
      children: [
        { key: 'report_header_config', label: 'Header Template' },
        { key: 'reporting_lock_config', label: 'Reporting Lock' },
      ],
    },
    {
      key: 'shortcuts',
      label: 'Shortcuts',
      icon: <ThunderboltOutlined />,
      children: [
        { key: 'shortcuts_admin', label: 'Manage Shortcuts' },
      ],
    },
    {
      key: 'library',
      label: 'Library',
      icon: <BookOutlined />,
      children: [
        { key: 'academics', label: 'Academics' },
      ],
    }
  ];

  const isIntegrationLogsEnabled = window.ENV_CONFIG?.ENABLE_INTEGRATION_LOGS || false;
  if (isIntegrationLogsEnabled) {
    items.push({
      key: 'integration_logs',
      label: 'Integration Logs',
      icon: <DatabaseOutlined />,
      children: [
        { key: 'hl7_logs_mwl', label: 'MWL Logs (Forwarding)' },
        { key: 'hl7_logs_oru', label: 'HIS Logs (Sign-off)' },
      ],
    });
  }

  // Only show Centre Billing section if enabled
  const isCentreBillingEnabled = window.ENV_CONFIG?.ENABLE_CENTRE_BILLING || false;
  if (isCentreBillingEnabled) {
    items.push({
      key: 'billing',
      label: 'Centre Billing',
      icon: <DollarOutlined />,
      children: [
        { key: 'pricing_list', label: 'Pricing Rules' },
        { key: 'add_pricing', label: 'Add Pricing Rule' },
        { key: 'cost_reports', label: 'Cost Reports' },
      ],
    });
  }

  // Manage Studies (permanent study delete + DICOM edit) — admin users only.
  if (getUserDetails()?.user_type === 'admin') {
    items.splice(1, 0, {
      key: 'study_admin',
      label: 'Manage Studies',
      icon: <DesktopOutlined />,
      children: [
        { key: 'manage_studies', label: 'Studies' },
      ],
    });
  }

  // Only show Security section if session tracking is enabled
  if (isSessionTrackingEnabled) {
    items.splice(2, 0, {
      key: 'security',
      label: 'Security',
      icon: <SafetyOutlined />,
      children: [
        { key: 'session_management', label: 'Session Management' },
      ],
    });
  }

  return items;
}
